// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__Wodfr","vLegacy":"SelectSecondary_vLegacy__3T2ql","error":"SelectSecondary_error__2v77P","disabled":"SelectSecondary_disabled__3M-Zw"};